import React from "react";
import { motion } from "framer-motion";
import { educationAnim, iconsAnim, nameAnim } from "./Education.anim";
import { useChangeDocumentTitle } from "../../helpers/useChangeDocumentTitle";
// import CertifySlider from "./CertifySlider/CertifySlider";
// import { web } from './Education.constants';

export default function Education({ pageTitle }) {
  useChangeDocumentTitle(pageTitle);

  return (
    <motion.section
      className="education"
      variants={educationAnim}
      initial="init"
      animate="anim"
      exit="end"
    >
      <motion.h2 variants={nameAnim}>University of North Texas</motion.h2>
      <motion.h3 variants={iconsAnim}>Aug 2011 - May 2015</motion.h3>
      <motion.h5 variants={iconsAnim}>
        Bachelor of Science in Computer Science
      </motion.h5>
      <motion.h5 variants={iconsAnim}>
        Computer Programming Contest Prize
      </motion.h5>

      {/* <CertifySlider category="Certification Info" data={web} /> */}
    </motion.section>
  );
}
